
export const simplemd = (text) => (text) ? text.replace(/\*\*(.*?)\*\*/gi,"<strong>$1</strong>") : '' 